import { render } from "./App.vue?vue&type=template&id=634d578a"
const script = {}

import exportComponent from "D:\\workspace\\002-公司网站\\01.Working\\04.Development\\trunk\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__